export default __webpack_public_path__ + "static/media/enjoyable-place-mobile@2x.bd35fc60.jpg";